import { render, staticRenderFns } from "./QuestionLayout.vue?vue&type=template&id=70c5a833&scoped=true&"
import script from "./QuestionLayout.vue?vue&type=script&lang=ts&"
export * from "./QuestionLayout.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionLayout.vue?vue&type=style&index=0&id=70c5a833&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c5a833",
  null
  
)

export default component.exports